<ng-content select="[stepperHeader]"></ng-content>
<div class="container">
  <div [style.display]="selected ? 'block' : 'none'">
    <ng-container [ngTemplateOutlet]="selected.content"></ng-container>
  </div>
</div>
<ng-content select="[stepperFooter]"></ng-content>